import React from 'react'

import EditCompanyProductForm from '../../modules/CompanyProduct/components/EditCompanyProductForm'
export default function EditCompanyProductPage() {
  return <EditCompanyProductForm />
}
